<span [class]="class">{{ displayString }}</span>
